export default __webpack_public_path__ + "static/media/coin_1gm.e82b1275.jpg";